window['skills_stats#index'] = function () {
  $('.skills-checkbox input').change(function () {
    $('.skills-checkbox input').not(this).prop('checked', false)
  })
}
